import { ApolloClient, InMemoryCache } from '@apollo/client';

const client = new ApolloClient({
  uri: process.env.GATSBY_STRAPI_URL + '/graphql' || 'http://localhost:1337/graphql',
  cache: new InMemoryCache(),
});
export default client;